<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-none d-md-block">
        <v-card class="mb-4">
          <v-card-title>{{ $t('userOrders.orderManagement') }}</v-card-title>
          <v-card-text>
            <v-tabs v-model="activeStatus" background-color="primary" dark>
              <v-tab v-for="status in orderStatuses" :key="status" @click="setActiveStatus(status)">{{ $t(`userOrders.${status}`) }}</v-tab>
            </v-tabs>
            <v-data-table 
              :headers="headers" 
              :items="orders" 
              class="elevation-1"
              :loading="loading"
              :items-per-page="itemsPerPage"
              :options="options"
            >
              <template v-slot:[`item.status`]="{ item }">
                {{ $t(`orderDetails.${item.status}`) }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon @click="viewOrder(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.productNames`]="{ item }">
                <v-list dense>
                  <v-list-item v-for="product in item.items" :key="product.name">
                      <v-row>
                        <v-col cols="2">
                          <v-list-item-avatar>
                            <v-img class="product-image" :src="product.image"></v-img>
                          </v-list-item-avatar>
                        </v-col>
                        <v-col cols="10">
                          <v-list-item-title>{{ product.name }}</v-list-item-title>
                        </v-col>
                      </v-row>
                    <v-divider v-if="product !== item.items[item.items.length - 1]"></v-divider>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:[`item.quantities`]="{ item }">
                <v-list dense>
                  <v-list-item v-for="product in item.items" :key="product.name">
                      <v-list-item-subtitle>
                        {{ product.quantity }}
                      </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </template>
              <template v-slot:[`item.unitPrices`]="{ item }">
                <v-list dense>
                  <v-list-item v-for="product in item.items" :key="product.name">
                      <v-list-item-subtitle>
                        {{ product.price }} USDT
                      </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 移动端使用卡片布局 -->
      <v-col cols="12" class="d-block d-md-none" v-for="order in orders" :key="order.id">
        <v-card class="mb-4">
          <v-card-title>
            {{ $t('userOrders.orderId') }}: {{ order.id }}
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="product in order.items" :key="product.name">
                  <v-row>
                    <v-col cols="4">
                  <v-list-item-avatar>
                    <v-img class="product-image" :src="product.image"></v-img>
                  </v-list-item-avatar>
                  </v-col>
                  <v-col cols="8">
                  <v-list-item-title>{{ product.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $t('userOrders.quantity') }}: {{ product.quantity }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ $t('userOrders.unitPrice') }}: {{ product.price }} USDT
                  </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-row>
              <v-col>
                <strong>{{ $t('userOrders.actualPayment') }}:</strong> {{ order.total }} USDT
              </v-col>
              <v-col>
                <strong>{{ $t('userOrders.transactionStatus') }}:</strong> {{ $t(`userOrders.${order.status}`) }}
              </v-col>
              <v-list-item-action>
                <v-btn icon @click="viewOrder(order)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  </template>
  
  <script>
  import { fetchUserOrders } from '@/api/apiService';
  
  export default {
    name: 'UserOrders',
    data() {
      return {
        orderStatuses: ['allOrders', 'pendingShipment', 'shipped', 'completed', 'afterSales'],
        activeStatus: 'allOrders',
        orders: [],
        loading: false,
        page: 1,
        itemsPerPage: 10,
        options: {},
      };
    },
    computed: {
      headers() {
        const currentLocale = this.$i18n.locale;
        return [
          { title: this.$t('userOrders.orderId', currentLocale), value: 'id' },
          { title: this.$t('userOrders.product', currentLocale), value: 'productNames' },
          { title: this.$t('userOrders.unitPrice', currentLocale), value: 'unitPrices' },
          { title: this.$t('userOrders.quantity', currentLocale), value: 'quantities' },
          { title: this.$t('userOrders.actualPayment', currentLocale), value: 'total' },
          { title: this.$t('userOrders.transactionStatus', currentLocale), value: 'status' },
          { title: this.$t('userOrders.transactionActions', currentLocale), value: 'actions', sortable: false },
        ];
      },
    },
    methods: {
      setActiveStatus(status) {
        this.loadOrders(status);
      },
      viewOrder(order) {
        this.$router.push(`/dashboard/order/${order.id}`);
        console.log(order, 'order');
      },
      loadOrders(status) {
        this.loading = true;
        if(status == '0'){
          status = 'allOrders';
        }
        fetchUserOrders(status, this.page, this.itemsPerPage, this.options).then(response => {
          this.orders = response.data.orders;
          console.log(response.data.orders,response.data, 'orders list');
          this.loading = false;
        });
      },
      handlePageChange(page) {
        this.page = page;
        this.loadOrders(this.activeStatus);
      },
      handleItemsPerPageChange(itemsPerPage) {
        this.itemsPerPage = itemsPerPage;
        this.loadOrders(this.activeStatus);
      },
    },
    mounted() {
      this.loadOrders(this.activeStatus);
    },
  };
  </script>
  
  <style scoped>
  .order-container {
    /* Styles */
  }
.order-list-container {
  padding: 20px;
  background-color: #f9f9f9;
}

.order-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.order-header {
  padding: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  background-color: #f5f5f5;
  border-radius: 8px 8px 0 0;
}

.order-items {
  padding: 10px;
}

.order-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 10px;
}

.item-details {
  flex: 1;
}

.item-name {
  font-weight: bold;
  margin-bottom: 5px;
}

.item-quantity,
.item-price {
  color: #555;
}

.no-orders {
  text-align: center;
  color: #888;
  font-size: 16px;
  margin-top: 20px;
}
</style>